import React from 'react';
import { BottleGlyph } from './ProductCard';
import { placeholderFor } from './productShopMapper';

// Basket view: line items with inline qty steppers + remove, a sticky subtotal
// footer, and Checkout / Continue shopping.

const MinusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" aria-hidden><path d="M5 12h14" /></svg>
);
const PlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" aria-hidden><path d="M12 5v14M5 12h14" /></svg>
);
const BagIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M5 11h14l-1 9a2 2 0 0 1-2 1.8H8a2 2 0 0 1-2-1.8L5 11z" /><path d="M9 11V8a3 3 0 0 1 6 0v3" />
  </svg>
);

const ProductCart = ({ lines, subtotal, currency = '£', onSetQty, onRemove, onCheckout, onContinue }) => {
  if (!lines.length) {
    return (
      <div className="ps-cart ps-cart--empty">
        <span className="ps-empty-glyph" aria-hidden><BagIcon /></span>
        <p className="ps-empty-title">Your basket is empty</p>
        <p className="ps-empty-sub">Add a few products to take home or have delivered.</p>
        <button type="button" className="ps-btn ps-btn--primary" onClick={onContinue}>Browse products</button>
      </div>
    );
  }

  // A line can go out of stock after it was added (the basket persists) —
  // surface it and hold checkout until it's removed; the server would reject
  // the order anyway.
  const oosLines = lines.filter((l) => l.inStock === false);

  return (
    <div className="ps-cart">
      <div className="ps-cart-lines">
        {lines.map((l) => {
          const img = l.variantImage || (l.images && l.images[0]);
          const thumbStyle = img ? { backgroundImage: `url(${img})` } : { background: placeholderFor(l.name.length) };
          return (
            <div className="ps-cart-line" key={`${l.id}:${l.variantId || ''}`}>
              <div className="ps-cart-thumb" style={thumbStyle}>{!img && <span className="ps-card-glyph" aria-hidden><BottleGlyph size={22} /></span>}</div>
              <div className="ps-cart-info">
                <h3 className="ps-cart-name">{l.name}</h3>
                {l.variantLabel && <p className="ps-cart-variant" style={{ margin: '2px 0 0', fontSize: 12, color: '#6b7280' }}>{l.variantLabel}</p>}
                <p className="ps-cart-line-price">{currency}{l.price.toFixed(2)}</p>
                {l.inStock === false && <p className="ps-cart-oos">Out of stock — remove to continue</p>}
                <button type="button" className="ps-cart-remove" onClick={() => onRemove(l.id, l.variantId)}>Remove</button>
              </div>
              <div className="ps-cart-right">
                <div className="ps-qty ps-qty--sm">
                  <button type="button" className="ps-qty-btn" onClick={() => onSetQty(l.id, l.qty - 1, l.variantId)} aria-label="Decrease quantity"><MinusIcon /></button>
                  <span className="ps-qty-num" key={l.qty}>{l.qty}</span>
                  <button type="button" className="ps-qty-btn" onClick={() => onSetQty(l.id, l.qty + 1, l.variantId)} aria-label="Increase quantity"><PlusIcon /></button>
                </div>
                <span className="ps-cart-linetotal">{currency}{l.lineTotal.toFixed(2)}</span>
              </div>
            </div>
          );
        })}
      </div>

      <div className="ps-cart-footer">
        <div className="ps-cart-subtotal"><span>Subtotal</span><strong>{currency}{subtotal.toFixed(2)}</strong></div>
        <p className="ps-cart-note">Shipping and collection options at checkout.</p>
        <button type="button" className="ps-btn ps-btn--primary ps-btn--lg" onClick={onCheckout} disabled={oosLines.length > 0}>
          {oosLines.length > 0 ? 'Remove out-of-stock items' : 'Checkout'}
        </button>
        <button type="button" className="ps-btn ps-btn--text" onClick={onContinue}>Continue shopping</button>
      </div>
    </div>
  );
};

export default ProductCart;
